export const OUTBOX_STATUSES = ["pending", "processing", "sent", "dead"] as const;

export type OutboxStatus = (typeof OUTBOX_STATUSES)[number];

export type OutboxNotificationFilters = {
  status?: OutboxStatus;
  type?: string;
  channel?: string;
  from?: string;
  to?: string;
  sortBy?: "updatedAt" | "createdAt" | "nextAttemptAt" | "attempts" | "status" | "channel" | "type";
  sortDirection?: "asc" | "desc";
};

export type OutboxNotificationSummary = {
  status: OutboxStatus;
  count: number;
  lastUpdatedAt: string | null;
};

export type OutboxNotificationItem = {
  id: string;
  channel: string;
  type: string;
  status: OutboxStatus;
  attempts: number;
  nextAttemptAt: string | null;
  updatedAt: string;
  lastError: string | null;
  userFullName: string | null;
  userEmail: string | null;
  organizationName: string | null;
};

export type OutboxNotificationPagination = {
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
};

export type OutboxNotificationList = {
  summary: OutboxNotificationSummary[];
  items: OutboxNotificationItem[];
  pagination: OutboxNotificationPagination;
};

export type OutboxNotificationExport = {
  data: BlobPart;
  contentType: string;
  filename: string;
};

export type OutboxNotificationDetailUser = {
  id: string;
  name: string;
  email: string;
};

export type OutboxNotificationDetailOrganization = {
  id: string;
  name: string;
};

export type OutboxNotificationDetail = OutboxNotificationItem & {
  createdAt: string;
  sentAt: string | null;
  user: OutboxNotificationDetailUser | null;
  organization: OutboxNotificationDetailOrganization | null;
  payloadJson: string;
  payloadValid: boolean;
};
